export default __webpack_public_path__ + "static/media/634.73e33b07.gif";